import React from "react";

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function inlineMarkdown(text) {
  let html = escapeHtml(text);
  // Complete pairs only — unfinished ** while streaming stay visible briefly until closed
  html = html.replace(/`([^`]+)`/g, "<code>$1</code>");
  html = html.replace(/\*\*\*([^*]+)\*\*\*/g, "<strong><em>$1</em></strong>");
  html = html.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  html = html.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, "$1<em>$2</em>");
  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  );
  // Soft-hide a trailing unfinished **bold opener during stream (e.g. "**React")
  html = html.replace(/\*\*([^*]*)$/g, "<strong>$1</strong>");
  html = html.replace(/(^|[^*])\*([^*\n]*)$/g, "$1<em>$2</em>");
  return html;
}

/**
 * Convert markdown to HTML. Safe for live streaming (partial bold/headings).
 */
export function markdownToHtml(content) {
  const raw = String(content || "").replace(/\r\n/g, "\n");
  if (!raw.trim()) return "";

  const lines = raw.split("\n");
  const blocks = [];
  let listType = null;
  let listItems = [];

  const flushList = () => {
    if (!listItems.length) return;
    const tag = listType === "ol" ? "ol" : "ul";
    blocks.push(
      `<${tag}>${listItems.map((item) => `<li>${inlineMarkdown(item)}</li>`).join("")}</${tag}>`
    );
    listItems = [];
    listType = null;
  };

  for (const line of lines) {
    const heading = line.match(/^\s*(#{1,3})\s+(.+)$/);
    const bullet = line.match(/^\s*[-*•]\s+(.+)$/);
    const numbered = line.match(/^\s*\d+\.\s+(.+)$/);

    if (heading) {
      flushList();
      const level = Math.min(heading[1].length, 3);
      blocks.push(`<h${level}>${inlineMarkdown(heading[2])}</h${level}>`);
      continue;
    }
    if (bullet) {
      if (listType && listType !== "ul") flushList();
      listType = "ul";
      listItems.push(bullet[1]);
      continue;
    }
    if (numbered) {
      if (listType && listType !== "ol") flushList();
      listType = "ol";
      listItems.push(numbered[1]);
      continue;
    }
    flushList();
    if (!line.trim()) {
      blocks.push("");
      continue;
    }
    blocks.push(`<p>${inlineMarkdown(line)}</p>`);
  }
  flushList();

  return (
    blocks
      .filter((b, i, arr) => !(b === "" && (i === 0 || arr[i - 1] === "")))
      .join("") || `<p>${inlineMarkdown(raw)}</p>`
  );
}

function ChatMarkdown({ content }) {
  const html = markdownToHtml(content);
  if (!html) return null;
  return <div className="chat-md" dangerouslySetInnerHTML={{ __html: html }} />;
}

export default ChatMarkdown;
